import React from 'react';
import * as styles from './index.module.less';
import { HEADER_NAV_DATA } from '@/layout/constants';
import Collapse from '@/components/collapse';
import NavTitle from '@/components/heading/NavTitle';
import NavCardItem from '../nav-card-item';

const SideNavBar = () => {
  return (
    <nav className={styles.side_nav_bar_wrapper}>
      {HEADER_NAV_DATA.map((item, index) => {
        return item.type === 'dropdown' ? (
          <Collapse
            style={{
              borderBottom: '1px solid #F0F0F0',
            }}
            key={index}
            title={
              <div className={styles.collapse_title}>
                <NavTitle>{item.label}</NavTitle>
              </div>
            }
            content={
              <div className={styles.collapse_content}>
                {item.dropdownList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={
                        !item.title
                          ? {
                              paddingLeft: '0px',
                            }
                          : {}
                      }
                      className={styles.dropdown_list_container}
                    >
                      {item.title && <NavTitle>{item.title}</NavTitle>}
                      <div className={styles.nav_list_container}>
                        {item.navItemList.map((item) => {
                          return (
                            <NavCardItem
                              key={item.link}
                              data={item}
                              isShowDesc={false}
                              style={{
                                width: '100%',
                              }}
                              isSideNavBar={true}
                            />
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            }
          />
        ) : (
          <a href={item.link} key={index} className={styles.side_nav_link}>
            <NavTitle>{item.label}</NavTitle>
          </a>
        );
      })}
    </nav>
  );
};
export default SideNavBar;
